export * from './marketing-consent';
